<template>
  <div class="view-wrap bg-dark">
    <div class="view-content bg-regular">
      <section>
        <div class="section-inner">
          <div class="container">
            <div class="top-copy">
              <h1>Legal Notices & Open Source Attribution</h1>
              <p>RememBear utilizes the following open source projects:</p>
            </div>
            <h3>All Platforms</h3>
            <ul>
              <li><a target="_blank" href="https://crates.io/crates/byteorder">byteorder</a></li>
              <li><a target="_blank" href="https://crates.io/crates/diceware-gen">diceware-gen</a></li>
              <li><a target="_blank" href="https://crates.io/crates/fast_chemail">fast_chemail</a></li>
              <li><a target="_blank" href="https://crates.io/crates/lazy_static">lazy-static</a></li>
              <li><a target="_blank" href="https://crates.io/crates/openssl">openssl</a></li>
              <li><a target="_blank" href="https://crates.io/crates/openssl-sys">openssl-sys</a></li>
              <li><a target="_blank" href="https://crates.io/crates/sodiumoxide">sodiumoxide</a></li>
              <li><a target="_blank" href="https://crates.io/crates/zxcvbn">zxcvbn</a></li>
            </ul>
            <h3>Windows</h3>
            <ul>
              <li><a target="_blank" href="https://github.com/aspnet/EntityFramework6">Microsoft EntityFramework6</a></li>
              <li><a target="_blank" href="https://github.com/bitstadium/HockeySDK-Windows">Microsoft HockeySDK.WPF</a></li>
              <li><a target="_blank" href="https://github.com/dotnet/corefx">Microsoft .NET CoreFX</a></li>
              <li><a target="_blank" href="https://github.com/unitycontainer">Microsoft Unity</a></li>
              <li><a target="_blank" href="http://logging.apache.org/log4net/">Apache log4net</a></li>
              <li><a target="_blank" href="https://github.com/higankanshi/Meta.Vlc">Meta.Vlc</a></li>
              <li><a target="_blank" href="http://www.galasoft.ch/mvvm">MvvmLight</a></li>
              <li><a target="_blank" href="https://developer.mozilla.org/en-US/docs/Mozilla/Projects/NSS">NSS</a></li>
              <li><a target="_blank" href="https://www.newtonsoft.com/json">Newtonsoft.Json</a></li>
              <li><a target="_blank" href="http://www.pdfsharp.net">PDFsharp</a></li>
              <li><a target="_blank" href="https://system.data.sqlite.org/index.html/doc/trunk/www/index.wiki">System.Data.SQLite</a></li>
              <li><a target="_blank" href="https://github.com/thomaslevesque/WeakEvent/">ThomasLevesque.WeakEvent</a></li>
              <li><a target="_blank" href="http://sta.github.io/websocket-sharp/">WebSocketSharp</a></li>
              <li><a target="_blank" href="https://github.com/Sascha-L/WPF-MediaKit">WPFMediaKit</a></li>
              <li><a target="_blank" href="https://github.com/trichards57/zxcvbn-cs">zxcvbn-cs</a></li>
              <li><a target="_blank" href="https://github.com/micjahn/ZXing.Net/">ZXing.Net</a></li>
              <li><a target="_blank" href="http://wixtoolset.org/">WiX Toolset</a></li>
              <li><a target="_blank" href="https://download.libsodium.org/doc/">libsodium</a></li>
              <li><a target="_blank" href="https://github.com/moq/moq4">Moq</a></li>
              <li><a target="_blank" href="http://www.castleproject.org/">Castle.Core</a></li>
              <li><a target="_blank" href="https://fonts.google.com/specimen/Roboto+Mono">Roboto Mono font</a></li>
            </ul>
            <h3>macOS</h3>
            <ul>
              <li><a target="_blank" href="https://github.com/yaslab/CSV.swift">CSV.swift</a></li>
              <li><a target="_blank" href="https://sparkle-project.org/">Sparkle</a></li>
              <li><a target="_blank" href="https://github.com/potionfactory/LetsMove/">LetsMove</a></li>
              <li><a target="_blank" href="https://try.crashlytics.com/">crashlytics</a></li>
              <li><a target="_blank" href="https://get.fabric.io/">fabric</a></li>
              <li><a target="_blank" href="https://github.com/zwopple/PocketSocket">PocketSocket</a></li>
              <li><a target="_blank" href="https://github.com/PerfectlySoft/Perfect-HTTP">Perfect-HTTP</a></li>
            </ul>
            <h3>iOS</h3>
            <ul>
              <li><a target="_blank" href="https://github.com/FredericJacobs/OpenSSL-Pod">OpenSSL</a></li>
              <li><a target="_blank" href="https://github.com/SVProgressHUD/SVProgressHUD">SVProgressHUD</a></li>
              <li><a target="_blank" href="https://github.com/jverdi/JVFloatLabeledTextField">JVFloatLabeledTextField</a></li>
              <li><a target="_blank" href="https://github.com/John-Lluch/SWRevealViewController">SWRevealViewController</a></li>
              <li><a target="_blank" href="https://github.com/davbeck/TUSafariActivity">TUSafariActivity</a></li>
            </ul>
            <h3>macOS/iOS</h3>
            <ul>
              <li><a target="_blank" href="https://github.com/Thomvis/BrightFutures">BrightFutures</a></li>
              <li><a target="_blank" href="https://github.com/antitypical/Result">Result</a></li>
              <li><a target="_blank" href="https://github.com/ccgus/fmdb">FMDB</a></li>
              <li><a target="_blank" href="https://libsodium.org">Libsodium</a></li>
              <li><a target="_blank" href="https://github.com/malcommac/SwiftDate">SwiftDate</a></li>
              <li><a target="_blank" href="https://github.com/Swinject/Swinject">Swinject</a></li>
              <li><a target="_blank" href="https://github.com/DaveWoodCom/XCGLogger">XCGLogger</a></li>
              <li><a target="_blank" href="https://github.com/marmelroy/Zip">Zip</a></li>
              <li><a target="_blank" href="https://github.com/samuelwford/swfsemanticversion">SWFSemanticVersion</a></li>
              <li><a target="_blank" href="https://github.com/evgenyneu/keychain-swift">KeychainSwift</a></li>
              <li><a target="_blank" href="https://github.com/dropbox/zxcvbn-ios">zxcvbn-ios</a></li>
              <li><a target="_blank" href="https://fonts.google.com/specimen/Roboto+Mono">Roboto Mono font</a></li>
              <li><a target="_blank" href="https://www.zetetic.net/sqlcipher/">SQLCipher</a></li>
            </ul>
            <h3>Android</h3>
            <ul>
              <li><a target="_blank" href="http://jakewharton.github.io/butterknife/">Butter Knife</a></li>
              <li><a target="_blank" href="https://google.github.io/dagger/">Dagger</a></li>
              <li><a target="_blank" href="http://facebook.github.io/rebound/">Facebook Rebound</a></li>
              <li><a target="_blank" href="https://github.com/mozilla-mobile/focus-android">Firefox Focus</a></li>
              <li><a target="_blank" href="http://square.github.io/okhttp/">OkHttp</a></li>
              <li><a target="_blank" href="https://www.guardsquare.com/en/proguard">ProGuard</a></li>
              <li><a target="_blank" href="http://square.github.io/retrofit/">Retrofit</a></li>
              <li><a target="_blank" href="https://github.com/ReactiveX/RxJava">RxJava</a></li>
              <li><a target="_blank" href="https://www.zetetic.net/sqlcipher/">SQLCipher</a></li>
            </ul>
            <h3>Website</h3>
            <ul>
              <li><a target="_blank" href="https://webpack.js.org/">Webpack</a></li>
              <li><a target="_blank" href="https://babeljs.io/">Babel</a></li>
              <li><a target="_blank" href="https://www.npmjs.com/">NPM</a></li>
              <li><a target="_blank" href="https://vuejs.org/">VueJS</a></li>
              <li><a target="_blank" href="https://vuex.vuejs.org/">Vuex</a></li>
              <li><a target="_blank" href="https://router.vuejs.org/">vue-router</a></li>
              <li><a target="_blank" href="https://github.com/axios/axios">Axios</a></li>
              <li><a target="_blank" href="https://github.com/js-cookie/js-cookie">js-cookie</a></li>
              <li><a target="_blank" href="http://stylus-lang.com/">Stylus</a></li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>

export default {
  name: 'notices',
  data () {
    return {}
  },
  methods: {}
}
</script>

<style scoped lang="stylus" src="./notices.styl" >



// WEBPACK FOOTER //
// src/views/notices/notices.vue